module.exports = __webpack_public_path__ + "static/media/payu.0f28e3a3.png";